import React from "react";
import { Box, Grid, InputLabel } from "@mui/material";
import AvatarPanel from "./AvatarPanel.tsx";
import SpreadsheetRow from "./SpreadSheetRow.tsx";
import { Trans } from "@lingui/react/macro";

interface ShowSpreadsheets {
  children?: React.ReactNode;
  content: Array<any>;
  role: string;
}

const ShowSpreadsheets: React.FC<ShowSpreadsheets> = (props) => {
  return (
    <Box marginBottom={"10%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid size={{ xs: 1, lg: 1 }}>
          <AvatarPanel />
        </Grid>
        <Grid size={{ xs: 11, lg: 11 }}>
          <InputLabel sx={{ marginBottom: "3%", marginTop: "1.5%" }}>
            <Trans
              context={"Input label listing all the spreadsheets of the tenant"}
            >
              Here is a list of your spreadsheets
            </Trans>
          </InputLabel>
          {props.content.map((item, index) => (
            <Box key={index}>
              <SpreadsheetRow
                index={index + 1}
                name={item.name}
                fileId={item.fileId}
                addedBy={item.added_by}
              />
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShowSpreadsheets;
